@if (savedCartsList$ | async; as savedCarts) {
  @if (!(isLoading$ | async)) {
    <div class="cx-saved-cart-list-header">
      <h3>
        {{
        'customSavedCartList.savedCarts' | cxTranslate: { count: savedCarts.length }
        }}
      </h3>
    </div>
    @if (savedCarts?.length > 0) {
      <table class="table cx-saved-cart-list-table">
        <thead class="cx-saved-cart-list-thead-mobile">
          <th scope="col">
            {{ 'customSavedCartList.cartName' | cxTranslate }}
          </th>
          <th scope="col">{{ 'customSavedCartList.cartId' | cxTranslate }}</th>
          <th scope="col">{{ 'customSavedCartList.dateSaved' | cxTranslate }}</th>
          <th scope="col" class="cx-saved-cart-list-center-text-align">
            {{ 'customSavedCartList.quantity' | cxTranslate }}
          </th>
          <th scope="col" class="cx-saved-cart-list-center-text-align">{{ 'customSavedCartList.total' | cxTranslate }}</th>
          <th scope="col" class="public-flag-col">{{ 'customSavedCartDetails.publicFlagColumn' | cxTranslate }}</th>
          <th scope="col">
            {{ 'customSavedCartList.actions' | cxTranslate }}
          </th>
        </thead>
        <tbody>
          @for (savedCart of savedCarts; track savedCart) {
            <tr
              (click)="goToSavedCartDetails(savedCart)"
              >
              <td class="cx-saved-cart-list-cart-name">
                <div class="cx-table-label-mobile cx-saved-cart-list-label">
                  {{ 'customSavedCartList.cartName' | cxTranslate }}
                </div>
                <a
                  [routerLink]="
                    {
                      cxRoute: 'savedCartsDetails',
                      params: { savedCartId: savedCart?.code }
                    } | cxUrl
                  "
                  class="cx-saved-cart-list-value"
                  >
                  {{ savedCart?.name }}</a
                  >
                </td>
                <td class="cx-saved-cart-list-cart-id">
                  <div class="cx-table-label-mobile cx-saved-cart-list-label">
                    {{ 'customSavedCartList.cartId' | cxTranslate }}
                  </div>
                  <a
                  [routerLink]="
                    {
                      cxRoute: 'savedCartsDetails',
                      params: { savedCartId: savedCart?.code }
                    } | cxUrl
                  "
                    class="cx-saved-cart-list-value"
                    >{{ savedCart?.code }}</a
                    >
                  </td>
                  <td class="cx-saved-cart-list-date-saved">
                    <div class="cx-table-label-mobile cx-saved-cart-list-label">
                      {{ 'customSavedCartList.dateSaved' | cxTranslate }}
                    </div>
                    <a
                  [routerLink]="
                    {
                      cxRoute: 'savedCartsDetails',
                      params: { savedCartId: savedCart?.code }
                    } | cxUrl
                  "
                      class="cx-saved-cart-list-value"
                      >{{ savedCart?.saveTime | date: datePattern }}</a
                      >
                    </td>
                    <td class="cx-saved-cart-list-quantity cx-saved-cart-list-center-text-align">
                      <div class="cx-table-label-mobile cx-saved-cart-list-label">
                        {{ 'customSavedCartList.quantity' | cxTranslate }}
                      </div>
                      <a
                  [routerLink]="
                    {
                      cxRoute: 'savedCartsDetails',
                      params: { savedCartId: savedCart?.code }
                    } | cxUrl
                  "
                        class="cx-saved-cart-list-value"
                        >
                        {{ savedCart?.totalUnitCount }}</a
                        >
                      </td>
                      <td class="cx-saved-cart-list-total cx-saved-cart-list-center-text-align">
                        <div class="cx-table-label-mobile cx-saved-cart-list-label">
                          {{ 'customSavedCartList.total' | cxTranslate }}
                        </div>
                        <a
                  [routerLink]="
                    {
                      cxRoute: 'savedCartsDetails',
                      params: { savedCartId: savedCart?.code }
                    } | cxUrl
                  "
                          class="cx-saved-cart-list-value"
                          >
                          {{ savedCart?.totalPrice?.formattedValue }}</a
                          >
                        </td>
                        <td class="cx-saved-cart-list-public-flag">
                          <div class="cx-table-label-mobile cx-saved-cart-list-label">
                            {{ 'customSavedCartDetails.publicFlagColumn' | cxTranslate }}
                          </div>
                          @if (savedCart?.publicCart) {
                            <a
                  [routerLink]="
                    {
                      cxRoute: 'savedCartsDetails',
                      params: { savedCartId: savedCart?.code }
                    } | cxUrl
                  "
                              class="cx-saved-cart-list-value"
                              >
                              {{ 'customSavedCartDetails.public' | cxTranslate }}</a
                              >
                            }
                            @if (!savedCart?.publicCart) {
                              <a
                [routerLink]="
                  {
                    cxRoute: 'savedCartsDetails',
                    params: { savedCartId: savedCart?.code }
                  } | cxUrl
                "
                                class="cx-saved-cart-list-value"
                                >
                                {{ 'customSavedCartDetails.private' | cxTranslate }}</a
                                >
                              }
                            </td>
                            <td class="cx-saved-cart-list-make-cart-active">
                              <div class="cx-table-label-mobile cx-saved-cart-list-label"></div>
                              @if (savedCart?.activeCartForUser) {
                                <a
                [routerLink]="
                {
                  cxRoute: 'savedCartsDetails',
                  params: { savedCartId: savedCart?.code }
                } | cxUrl
                "
                                  class="cx-saved-cart-list-value"
                                  >
                                  {{ 'customSavedCartDetails.active' | cxTranslate }}
                                </a>
                              } @else {
                                <button
                                  class="link cx-action-link cx-saved-cart-make-active"
                                  (click)="restoreSavedCart($event, savedCart?.code)"
                                  [disabled]="isRestricted"
                                  >
                                  {{ 'customSavedCartList.makeCartActive' | cxTranslate }}
                                </button>
                              }
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  } @else {
                    <div class="cx-saved-cart-list-no-saved-carts row">
                      <div class="col-sm-12 col-md-6 col-lg-4">
                        <div>{{ 'customSavedCartList.notFound' | cxTranslate }}</div>
                      </div>
                    </div>
                  }
                  <!-- NO SAVED CART CONTAINER -->
                } @else {
                  <div class="cx-spinner">
                    <cx-spinner></cx-spinner>
                  </div>
                }
              }
